import api from "./client";
import { openAuthenticatedPdf } from "./pdf";

// Client pro-formas (PF-<booking>-NN, paid upfront). Separate from invoices:
// the VAT invoice for the period is raised after the period.
export const getProformas = (params) => api.get("/proformas", { params });
export const getProformaPrefill = (params) => api.get("/proformas/prefill", { params });
export const createProforma = (data) => api.post("/proformas", data);
export const updateProforma = (proformaId, data) => api.patch(`/proformas/${proformaId}`, data);
export const pushProformaToXero = (proformaId) => api.post(`/proformas/${proformaId}/push-to-xero`);
export const setProformaStatus = (proformaId, data) => api.post(`/proformas/${proformaId}/status`, data);
export const voidProforma = (proformaId) => api.post(`/proformas/${proformaId}/void`);
export const importProformasFromXero = (bookingId) =>
  api.post("/proformas/import-xero", null, { params: { booking_id: bookingId } });
export const openProformaPdf = (proformaId) => openAuthenticatedPdf(`/proformas/${proformaId}/pdf`);
